module.exports = __webpack_public_path__ + "static/media/device_info_qrcode_icon.8e097359.svg";